import { toast } from 'react-toastify';
import { useAuth } from '../../../hooks/useAuth';
import { string_to_slug } from '../../../utils/slug';
import { useEnv } from '../../../context/env-context';
import { makeRequest } from '../../../utils/makeRequest';
import Dropdown from 'react-bootstrap/Dropdown';

function ConsumersActions({ selectedAggregatorFilter, spinner, setSpinner }) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const getConsumersFile = async () => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return null;
    }

    const config = {
      token,
      url: `${apiOriginConsumer}/export`,
      method: 'GET',
      params: { aggregatorId: selectedAggregatorFilter },
    };

    try {
      const data = await makeRequest(config);

      return data;
    } catch (error) {
      toast.error(error.message);

      return null;
    } finally {
      setSpinner(false);
    }
  };

  const downloadConsumersFile = async () => {
    const binaryData = [];
    const data = await getConsumersFile();

    if (data) {
      binaryData.push(data);
      const url = window.URL.createObjectURL(new Blob(binaryData));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', `consumers_${string_to_slug('AAA')}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  return (
    <Dropdown>
      <Dropdown.Toggle className="bo-dropdown" disabled={spinner}>
        Actions&nbsp;&nbsp;&nbsp;
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="bo-dropdown-menu"
        popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
      >
        <Dropdown.Item className="bo-dropdown-menu-item" disabled={selectedAggregatorFilter === ''}>
          Change status - Bulk
        </Dropdown.Item>
        <Dropdown.Item
          className="bo-dropdown-menu-item"
          disabled={selectedAggregatorFilter === ''}
          onClick={downloadConsumersFile}
        >
          Export
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default ConsumersActions;
